import {
  Component, Directive, ElementRef, Renderer, ChangeDetectionStrategy, ViewEncapsulation,
  HostListener
} from '@angular/core';
import { OnInit } from '@angular/core';



import { AppDataService } from './services/index';
import { _ParseAST } from '@angular/compiler';
import {TranslationService} from './services/translation.service';





@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'app-root',
  templateUrl: 'app.component.html'

})
export class AppComponent implements OnInit {
  public constructor(
                     public _appData: AppDataService,
                     public translate: TranslationService) {

                      translate.setDefaultLang('en');
                      // the lang to use, if the lang isn't available, it will use the current loader to get them                                       
  }


  public ngOnInit(): void {
    this._appData.lazyLoadComplete=false;

 

 
  }

 


  


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/app.component.ts